import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import ADIpdpUpdateTabState  from "../Data/ADIUpdatePDPTabsState";

const initialState: ADIpdpUpdateTabState = {
    currentActiveTab: "OverviewTitle",
    selectedMVPImage: Object
};

const reducer = {
    "Data/PDP/UpdatePDPTabs": (draft: Draft<ADIpdpUpdateTabState>, action: { result: string }) => {
        draft.currentActiveTab = action.result;
    },
    "Data/PDP/selectedMVPImage" : (draft: Draft<ADIpdpUpdateTabState>, action: { result: any }) => {
        draft.selectedMVPImage = action.result;
    }
};

export default createTypedReducerWithImmer(initialState, reducer);
